import { createStore } from 'redux'

const initialState = {
    region: {
        list: {},
        checked: {
            _id: 0,
            name: '全国'
        }
    },
}

const Reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_REGION':
            state.region.checked = action.region
            return { ...state }
        case 'SET_REGIONLIST':
            state.region.list = action.regionList
            return { ...state }
        default:
            return state;
    }
}

export const sotre = createStore(Reducer);
export default sotre;